import ar from "./ar";
import en from "./en";
import tr from "./tr";
import { createTranslator } from "./translate";

export const CATALOGS = { en, ar, tr };

export const LANGUAGES = [
  { code: "EN", locale: "en", dir: "ltr", htmlLang: "en" },
  { code: "AR", locale: "ar", dir: "rtl", htmlLang: "ar" },
  { code: "TR", locale: "tr", dir: "ltr", htmlLang: "tr" },
];

export const DEFAULT_LOCALE = "en";
export const STORAGE_KEY = "godo-lang";

export const getLanguage = (localeOrCode) => {
  const value = String(localeOrCode || "").toLowerCase();
  return (
    LANGUAGES.find(
      (item) => item.locale === value || item.code.toLowerCase() === value
    ) || LANGUAGES[0]
  );
};

/** True when value is a supported path locale (`en` | `ar` | `tr`). */
export const isSupportedLocale = (value) => {
  const normalized = String(value || "").toLowerCase();
  return LANGUAGES.some((item) => item.locale === normalized);
};

/** First path segment if it is a supported locale, otherwise null. */
export const getLocaleFromPath = (pathname) => {
  const segment = String(pathname || "")
    .replace(/^\/+|\/+$/g, "")
    .split("/")[0]
    ?.toLowerCase();
  return isSupportedLocale(segment) ? segment : null;
};

/** Build a same-app path under the given locale (keeps trailing segments). */
export const withLocalePath = (locale, pathname = "/", search = "", hash = "") => {
  const nextLocale = getLanguage(locale).locale;
  const trimmed = String(pathname || "/").replace(/^\/+|\/+$/g, "");
  const segments = trimmed ? trimmed.split("/") : [];
  const rest = isSupportedLocale(segments[0]) ? segments.slice(1) : segments;
  const path = rest.length ? `/${nextLocale}/${rest.join("/")}` : `/${nextLocale}`;
  return `${path}${search || ""}${hash || ""}`;
};

export const getTranslator = (locale) =>
  createTranslator(CATALOGS[getLanguage(locale).locale], CATALOGS.en);
